const ROOT = 'filtered/'

export default {
	arrayListFavorites: `${ROOT}favorites/list/`,
	show: `${ROOT}`
}
